import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map, throwError } from 'rxjs';
import { AuthService } from '../../../app/auth/auth.service';
import { environment } from '../../../environments/environment';
import { CompanyContextService } from '../../company-context.service';

export interface DsoAsAtResult {
  value: number | null;
}

interface DsoAsAtKpiPayload {
  Value?: number | string | null;
}

interface DsoAsAtApiResponse {
  data?: {
    kpi?: DsoAsAtKpiPayload | null;
  } | null;
}

@Injectable({ providedIn: 'root' })
export class DsoAsAtService {
  private readonly http = inject(HttpClient);
  private readonly auth = inject(AuthService);
  private readonly companyContext = inject(CompanyContextService);
  private readonly apiUrl = environment.dsoAsAtApiUrl;

  getDsoAsAt(asOfDate: string): Observable<DsoAsAtResult> {
    const compId = this.resolveCompanyId();
    if (compId == null) {
      return throwError(() => new Error('A company must be selected before loading DSO.'));
    }

    const params = new HttpParams()
      .set('asOfDate', asOfDate)
      .set('compId', compId);

    return this.http.get<DsoAsAtApiResponse>(this.apiUrl, { params }).pipe(
      map(response => {
        const rawValue = response.data?.kpi?.Value;
        const numericValue = rawValue == null ? null : Number(rawValue);

        return {
          value: numericValue != null && Number.isFinite(numericValue) ? numericValue : null,
        };
      })
    );
  }

  private resolveCompanyId(): number | null {
    const user = this.auth.session()?.user;
    if (!user) return null;

    return user.isSuperAdmin
      ? this.companyContext.getSelectedCompanyId(user.id) ?? user.compId
      : user.compId;
  }
}
